<template>
    <div class="body-container">
        <BannerSection title="Préstamo por título de carro"
                       subtitle="Rápido, seguro y sin dejar de usar tu auto" />
        <PerksComponent></PerksComponent>
        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <h1 class="title"><b>Préstamos por Título de Carro</b></h1>
                    <p class="regular-text">
                        ¿Sabías que puedes aprovechar el valor de tu auto sin dejar de manejarlo? <b>Los préstamos por
                            título de carro</b> son una solución rápida y accesible para obtener dinero cuando más lo
                        necesitas, usando tu vehículo como respaldo.
                    </p>
                    <p class="regular-text">
                        Aquí te contaremos todo lo que necesitas saber para solicitar uno, asegurarte de hacerlo de
                        manera segura y encontrar las mejores opciones cerca de ti.
                    </p>
                    <br>
                    <span>
                        <h2 class="h2-title"><b>¿Cómo funcionan los préstamos por auto sin dejarlo?</b></h2>
                    </span>
                    <p class="regular-text">
                        Con los préstamos con garantía automotriz, puedes utilizar el valor de tu auto para obtener un
                        financiamiento, pero manteniendo el vehículo bajo tu control. Esto significa que seguirás
                        manejando tu auto mientras pagas el préstamo. Este tipo de préstamos es ideal porque:
                    </p>
                    <ul>
                        <li>
                            <p class="regular-text">Ofrecen una aprobación rápida</p>
                        </li>
                        <li>
                            <p class="regular-text">No necesitas vender tu auto ni dejarlo estacionado en una
                                institucion</p>
                        </li>
                    </ul>
                    <p class="regular-text">En Ibancar, el proceso de solicitud es sencillo y 100% en línea, recibe una
                        preaprobación en
                        minutos. Además, aceptamos a personas en Buró de Crédito, lo que lo hace aún más accesible, y
                        abonas a capital desde el primer momento. </p>
                    <br>

                    <h2 class="h2-title"><b>Cómo obtener préstamos por título de carro cerca de ti</b></h2>

                    <p class="regular-text">¿Te preguntas: "¿Cómo encuentro <b>préstamos por título de carro cerca de
                            mí</b>?"? La respuesta
                        es más simple de lo que piensas. Hoy en día, muchas empresas permiten este tipo de préstamo,
                        pero, sólo algunas como Ibancar, te permiten realizar la solicitud en línea sin necesidad de
                        salir de casa. </p>

                    <p class="regular-text">En Ibancar, con solo proporcionar algunos datos basicos de tu vehiculo y tu
                        informacion personal,
                        puedes obtener una buena respuesta en minutos y el <b>dinero en menos de 24 horas.</b></p>

                    <p class="regular-text"><b>Nuestro consejo:</b> busca empresas confiables que estén registradas ante
                        PROFECO y que
                        ofrezcan transparencia en sus condiciones o costos ocultos. Si estás interesado en <a
                           href="https://ibancar.mx/prestamo-factura-auto"
                           target="
                           _blank">préstamos por factura de carro</a> o buscas
                        <a href="https://ibancar.mx/prestamo-con-garantia-de-auto-sin-dejarlo"
                           target="
                           _blank">préstamos con garantía de
                            auto sin dejarlo</a>, asegúrate de elegir opciones que prioricen tu comodidad y seguridad.
                    </p>
                    <br>
                    <h2 class="h2-title">
                        <b>Empeñar título de carro: ¿Qué debes considerar?</b>
                    </h2>
                    <p class="regular-text">Si estás pensando en <b>empeñar título de carro cerca de mí</b>, hay algunos
                        puntos clave que
                        debes tomar en cuenta para tomar la mejor decisión:</p>
                    <ol>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Términos del préstamo</b>
                            </p>
                            <p class="regular-text"> Verifica tasas de interés, mensualidades y si puedes abonar a
                                capital desde el
                                principio.</p>
                        </li>

                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Requisitos:</b>
                            </p>
                            <p class="regular-text">Asegúrate de cumplir con documentos básicos como la factura del
                                vehículo y una
                                identificación oficial (INE)</p>
                        </li>


                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Confiabilidad de la empresa</b>
                            </p>
                            <p class="regular-text">Opta por instituciones con buena reputación y experiencia en el
                                mercado, como Ibancar.
                            </p>
                        </li>
                        <br>
                    </ol>
                    <h2 class="h2-title">
                        <b>Encuentra préstamos por título de carro seguros y confiables</b>
                    </h2>
                    <p class="regular-text">Un préstamo seguro es aquel que garantiza <b>claridad desde el
                            principio</b>. En Ibancar no
                        pedimos que dejes tu auto.</p>
                    <p class="regular-text">Además, los préstamos son personalizados, adaptados a tu situación
                        financiera, y siempre sabes
                        cuánto vas a pagar <b>sin sorpresas al final</b>. Si buscas un <a
                           href="https://ibancar.mx/prestamo-sobre-vehiculo"
                           target="
                           _blank">préstamo sobre vehículo</a>, considera
                        opciones que te permitan mantener el control total sobre tu auto y brinden procesos
                        transparentes y rápidos.</p>
                    <br>

                    <h2 class="h2-title">
                        <b>Consejos para empeñar tu título de carro con éxito:</b>
                    </h2>
                    <ol>
                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Evalúa tu capacidad de pago:</b>
                            </p>
                            <p>Antes de solicitar un préstamo, calcula si podrás cumplir con los pagos mensuales.</p>
                        </li>

                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Mantén tu auto en buen estado:</b>
                            </p>
                            <p class="regular-text">Esto incrementará su valor y, por lo tanto, el monto del préstamo
                                que puedes recibir.</p>
                        </li>


                        <li class="mb-0 regular-text">
                            <p class="mb-0 regular-text">
                                <b>Elige bien el plazo del préstamo:</b>
                            </p>
                            <p class="regular-text">Busca opciones flexibles que se ajusten a tus necesidades
                            </p>
                        </li>
                    </ol>
                </div>
            </div>
        </div>


        <div style="background-color: rgba(255, 165, 0, 0.04); padding: 1.5rem 0rem; margin: 0rem 0rem;">
            <div class="ibancar-election">
                <p>¿Por qué elegir Ibancar?</p>
            </div>
            <BeneficiosIbancarCarousel />
        </div>


        <div class="section-container regular-text">
            <div class="position-relative  pb-3 pb-md-0 ">
                <div class="text-container">
                    <span class="bold-text">
                        <b>
                            <h2 class="h2-title">FAQs sobre el Préstamo personal</h2>
                        </b>
                        <br>
                    </span>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Cuánto puedo obtener con mi auto?</p>
                        <p class="regular-text">En Ibancar puedes recibir desde $12,000 hasta $120,000 MXN, dependiendo
                            del valor de tu
                            vehículo.</p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Qué pasa si estoy en Buró de Crédito?
                        </p>
                        <p class="regular-text">Aceptamos solicitudes de personas en Buró. Nos enfocamos en el valor de
                            tu auto, no en tu
                            historial crediticio. </p>
                    </div>
                    <div>
                        <p style="font-size: 23px; font-style: italic;"
                           class="regular-text">- ¿Cuánto tiempo tarda el proceso?</p>
                        <p class="regular-text">Con nosotros, puedes obtener el dinero en menos de 24 horas.
                        </p>
                    </div>
                    <br>
                    <p class="regular-text">Solicitar un <b>préstamo por título</b> de carro es una excelente manera de
                        obtener dinero rápido
                        y seguro sin desprenderte de tu vehículo. </p>
                    <p class="regular-text">Si estás buscando opciones confiables y flexibles, en Ibancar estamos para
                        ayudarte con procesos
                        claros, rápidos y sin salir de casa. ¡Solicita tu préstamo hoy mismo y descubre cómo tu auto
                        puede ser tu mejor aliado!</p>
                </div>

            </div>

        </div>
        <SolicitaloBannerS2 />
    </div>
</template>

<script>
import { useMeta } from 'vue-meta';
import BannerSection from '@/components/Landings/BannerSection.vue';
import BeneficiosIbancarCarousel from '@/components/PrestamoGarantiaAuto/BeneficiosIbancarCarousel.vue';
import SolicitaloBannerS2 from '@/components/Landings/SolicitaloBannerS2.vue';
import PerksComponent from '../components/PerksComponent.vue';


export default {
    name: 'PrestamoTituloDeCarro',
    components: {
        BannerSection,
        BeneficiosIbancarCarousel,
        SolicitaloBannerS2,
        PerksComponent
    },
    setup() {
        useMeta(
            {
                title: 'Préstamo por título de carro cerca de mí | IBANCAR México',
                meta: [
                    {
                        name: 'robots',
                        content: 'index'
                    },
                    {
                        name: 'description',
                        content: 'Descubre cómo obtener préstamos por título de carro cerca de ti con IBANCAR México, de manera segura, confiable y en línea. ¡Solicita hoy mismo!'
                    },
                    {
                        name: 'keywords',
                        content: 'préstamos por título de carro, préstamos por título de carro cerca de mi, empeñar título de carro cerca de mí'
                    }
                ],
                link: [
                    // { href: 'https://ibancar.com/prestamos-con-aval-de-coche-sin-cambiar-de-titular', rel: 'alternate', hreflang: 'es-es' },
                    { href: 'https://ibancar.mx/prestamo-titulo-carro', rel: 'alternate', hreflang: 'es-MX' }
                ]
            }
        )
    },

    data() {
        return {
            ventajas: [
                {
                    image: 'image12.svg',
                    title: 'Ejecutivo personalizado',
                },
                {
                    image: 'solicitud-en-linea.svg',
                    title: 'Proceso simple sin salir de casa',
                },

                {
                    image: 'prestamos-48-hrs.svg',
                    title: 'Hasta $120,000 en 24H',
                },
                {
                    image: 'proceso-simple.svg',
                    title: 'Aceptamos personas en Buró.',
                }

            ]
        }
    }
}
</script>

<style scoped lang="scss">
@import 'bootstrap/scss/_functions.scss';
@import 'bootstrap/scss/_variables.scss';
@import 'bootstrap/scss/_mixins.scss';


.image-container {
    text-align: center;
    margin: 3rem 0rem;

    img {
        max-height: 400px;
    }
}

.body-container {
    margin-top: 4.5rem;
    min-height: calc(100vh - 115px);
}

@include media-breakpoint-up(md) {
    .body-container {
        margin-top: 8.5rem;
    }
}

.ibancar-election {
    margin: 1rem 2rem 0rem 2rem;

    p {
        color: #004680;
        text-align: center;
        font-family: 'Montserrat-Bold';
        font-size: 1.3rem;
        font-style: normal;
        line-height: normal;
        margin: 1.5rem 0rem;
    }
}

.text-container {
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    font-size: 20px;
    text-align: justify;
}

.regular-text {
    font-family: "Montserrat";
    font-size: 20px;
    line-height: 30px;
}

.bold-text {
    font-family: "Montserrat-Bold";
}

.text-orange {
    color: $orange;
}

.text-blue {
    color: $blue;
}

.text-black {
    color: $black;
}

.text-underline {
    text-decoration: underline;
}


.btn-solicitar {
    a {
        &:hover {
            text-decoration: none;
        }
    }
}

// Image
.image {
    bottom: 0;
    right: 0;
    width: 30%;
    z-index: -1;
}

@include media-breakpoint-down(md) {
    .text-container {
        width: 90%;
    }

    .regular-text {
        line-height: 1.5;
    }

    ul {
        padding-inline-start: 20px;
    }

    ol {
        padding-inline-start: 20px;
    }

    p,
    h1,
    h2,
    h3,
    h4 {
        text-align: left;
    }
}

@include media-breakpoint-between(md, lg) {
    .regular-text {
        font-size: 16px;
    }

    .subtitle {
        font-size: 16px;
    }
}

@include media-breakpoint-down(sm) {
    .title {
        font-size: 23px;
        line-height: 25px;
    }

    .h2-title {
        font-size: 18px;
        line-height: 20px;
    }

    .h3-title {
        font-size: 16px;
        line-height: 15px;
    }

    .regular-text {
        font-size: 14px !important;
    }

    .section-container {
        margin-top: 1.5rem;
    }
}
</style>